import { useQuery } from 'react-query'
import { QueryNames } from 'Hooks/api/queryNames'
import { getEmployerMetaFields } from 'Services/employerService'
import { useErrorReporter } from 'Hooks/useErrorReporter'

export const useGetEmployerMetaFields = (employerId?: number) => {
  const reportError = useErrorReporter()

  return useQuery({
    queryKey: [QueryNames.EmployerMetaFields, employerId],
    queryFn: async () => {
      if (employerId === undefined) return []
      return await getEmployerMetaFields(employerId)
    },
    staleTime: 5 * 60 * 1000,
    enabled: employerId !== undefined,
    onError: (err: any) => {
      reportError(`useGetEmployerMetaFields error: ${err}`)
    }
  })
}
